import React, { Component }  from 'react'
import { Icon, Button, Confirm, Popup } from 'semantic-ui-react'

class ApplicantsDelete extends Component {
  state = { open: false }

  show = () => this.setState({ open: true })
  handleConfirm = () => {
    this.props.handleDelete(this.props.applicantId)
    this.setState({ open: false })
  }
  handleCancel = () => this.setState({ open: false })

  render() {
    return (
      <span>
        <Popup
          on='hover'
          position='bottom center'
          size='tiny'
          trigger={
            <Button icon size='tiny' onClick={this.show}>
              <Icon name='trash' />
            </Button>
          }
        >
          Delete Applicant
        </Popup>
        <Confirm
          open={this.state.open}
          header=''
          content={`Are you sure you want to delete student: ${this.props.applicantName}?`}
          onCancel={this.handleCancel}
          onConfirm={this.handleConfirm}
        />
    </span>
    )
  }
};

export default ApplicantsDelete;
